import { RegisterStepper } from "./RegisterStepper";

export default function RegisterFlow() {
  return <RegisterStepper />;
}
